"use client";

import React from "react";
import Image from "next/image";
import { useAtom } from "jotai";

import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Paragraph, Text } from "@/components/ui/typography";

import { emiRequestModalAtom } from "@/store/course";

function EmiRequestModal() {
  const [isOpen, setIsOpen] = useAtom(emiRequestModalAtom);

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogContent className="sm:max-w-95" showCloseButton={false}>
        <DialogTitle className="hidden">Emi Request Modal</DialogTitle>
        <div className="flex flex-col items-center-safe space-y-5">
          <Image
            src="/studyiq-next/images/vectors/emi-calendar.png"
            alt="Emi Calendar"
            width={149}
            height={100}
          />

          <div className="space-y-3">
            <Paragraph
              variant="b1-tight"
              weight="sb"
              className="text-grayscale-header-weak text-center"
            >
              EMI Request Received!
            </Paragraph>
            <Text
              variant="small-tight"
              className="text-grayscale-label block text-center"
            >
              One of our counsellors will get in touch with you within 24 hours
              to guide you through the next steps.
            </Text>
          </div>
        </div>

        <Button onClick={() => setIsOpen(false)} className="w-full mt-4">
          Got it
        </Button>

        <Paragraph
          variant="b5-tight"
          className="text-grayscale-label text-center"
        >
          Coupons cannot be applied when paying via EMI.
        </Paragraph>
      </DialogContent>
    </Dialog>
  );
}

export default EmiRequestModal;
